export default "__VITE_ASSET__1eimCyN___"